var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "25px" } },
        [
          _c("a-input", {
            attrs: { "addon-before": "标题", placeholder: "请输入标题" },
            model: {
              value: _vm.richTitle,
              callback: function ($$v) {
                _vm.richTitle = $$v
              },
              expression: "richTitle",
            },
          }),
        ],
        1
      ),
      _c("WangEditor", {
        model: {
          value: _vm.richText,
          callback: function ($$v) {
            _vm.richText = $$v
          },
          expression: "richText",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }